enum PAYMENT_PROVIDERS {
  paycomet = 'PAYCOMET',
  stripe = 'STRIPE',
  addon = 'ADDON',
}

enum PAYMENTS_SETTINGS_STATUSES {
  new = 'NEW',
  validating = 'VALIDATING',
  valid = 'VALID',
  invalid = 'INVALID',
}

enum RESERVATION_PAYMENT_TYPES {
  upselling = 'UPSELLING',
  touristTaxes = 'TOURIST_TAXES',
  booking = 'BOOKING',
  pmsIntegration = 'PMS_INTEGRATION',
  extraService = 'EXTRA_SERVICE',
  damageProtection = 'DAMAGE_PROTECTION',
  securityDeposit = 'SECURITY_DEPOSIT',
  upsellingThirdParty = 'UPSELLING_3D_PARTY',
}

enum MULTI_PAYMENT_STEP_TYPES {
  paymentSetupConfirmation = 'PAYMENT_SETUP_CONFIRMATION',
  paymentSetupInit = 'PAYMENT_SETUP_INIT',
  taxesSetup = 'TAXES_SETUP',
  securityDeposit = 'CREATE_SECURITY_DEPOSIT_PAYMENTS',
  damageProtection = 'CREATE_DAMAGE_PROTECTION_PAYMENT',
  retention = 'CREATE_RETENTION_PAYMENTS',
  instantPayment = 'CREATE_INSTANT_PAYMENT',
}

enum MULTI_PAYMENT_STEP_STATUSES {
  new = 'NEW',
  inProgress = 'IN_PROGRESS',
  dataRequired = 'DATA_REQUIRED',
  error = 'ERROR',
  complete = 'COMPLETE',
  skipped = 'SKIPPED',
}

enum MULTI_PAYMENT_STATUSES {
  new = 'NEW',
  inProgress = 'IN_PROGRESS',
  failed = 'FAILED',
  complete = 'COMPLETE',
}

enum SUMMARY_PAYMENTS_STATUSES {
  configurationPending = 'CONFIGURATION_PENDING',
  readyForPayment = 'READY_FOR_PAYMENT',
  payOnArrival = 'PAY_ON_ARRIVAL',
  complete = 'COMPLETE',
  inactive = 'INACTIVE',
}

export {
  PAYMENT_PROVIDERS,
  PAYMENTS_SETTINGS_STATUSES,
  RESERVATION_PAYMENT_TYPES,
  MULTI_PAYMENT_STEP_TYPES,
  MULTI_PAYMENT_STATUSES,
  MULTI_PAYMENT_STEP_STATUSES,
  SUMMARY_PAYMENTS_STATUSES,
};
